var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 1.5H12.5V0.5C12.5 0.2235 12.2765 0 12 0C11.7235 0 11.5 0.2235 11.5 0.5V1.5H8.5V0.5C8.5 0.2235 8.276 0 8 0C7.724 0 7.5 0.2235 7.5 0.5V1.5H4.5V0.5C4.5 0.2235 4.276 0 4 0C3.724 0 3.5 0.2235 3.5 0.5V1.5H1.3335C0.597 1.5 0 2.0965 0 2.833V14.6665C0 15.403 0.597 16 1.3335 16H14.667C15.4035 16 16 15.403 16 14.6665V2.833C16 2.0965 15.4035 1.5 14.667 1.5ZM15 14.6665C15 14.8505 14.8505 15 14.667 15H1.3335C1.1495 15 1 14.8505 1 14.6665V2.833C1 2.6495 1.1495 2.5 1.3335 2.5H3.5V3.5C3.5 3.7765 3.724 4 4 4C4.276 4 4.5 3.7765 4.5 3.5V2.5H7.5V3.5C7.5 3.7765 7.724 4 8 4C8.276 4 8.5 3.7765 8.5 3.5V2.5H11.5V3.5C11.5 3.7765 11.7235 4 12 4C12.2765 4 12.5 3.7765 12.5 3.5V2.5H14.667C14.8505 2.5 15 2.6495 15 2.833V14.6665Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6H3.5V7.5H5.5V6Z",
    fill: "#858585"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.5H3.5V10H5.5V8.5Z",
    fill: "#858585"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11H3.5V12.5H5.5V11Z",
    fill: "#858585"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11H7V12.5H9V11Z",
    fill: "#858585"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.5H7V10H9V8.5Z",
    fill: "#858585"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6H7V7.5H9V6Z",
    fill: "#858585"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11H10.5V12.5H12.5V11Z",
    fill: "#858585"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.5H10.5V10H12.5V8.5Z",
    fill: "#858585"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6H10.5V7.5H12.5V6Z",
    fill: "#858585"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.093a46ff8b4346347784409c4e6ddde3.svg";
export { ForwardRef as ReactComponent };